export function snakeCaseToCamelCaseString(string) {
  return string?.replace(/_([a-z])/g, function(g) {
    return g[1].toUpperCase()
  })
}

export function camelCaseToSnakeCaseString(string) {
  return string
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase()
}
